export default {
  formasLeitura: [],
  formaLeituraEmEdicao: {},
  referenciaEmEdicao: {},
  leituras: [],
  leituraEmEdicao: {},
  loading: false,
}
